import { formatPrice } from "helpers/formatPrice";
import { isEmpty, isNull } from "lodash";

const { useSelector } = require("react-redux");
const { default: selectors } = require("selectors");

const useSubscriptionPlan = (billingCycle, externalPrices = null, isFreeTier = false) => {
  if(isFreeTier) return {}
  const tierInfo = useSelector(selectors.memberTier);
  const promo = useSelector(selectors.promo);

  if (!billingCycle) return {};

  const { coupon } = promo;
  const { amount_off: amountOff, percent_off: percentOff } = coupon || {};

  const prices = (externalPrices && externalPrices.length > 0)
    ? externalPrices
    : (tierInfo?.prices || []);

  if(isEmpty(prices)) return {};

  const selectedPlan = prices.find((p) => p.interval === billingCycle);
  const interval = selectedPlan?.interval;
  const monthlyPlan = prices?.find((item) => item.interval === "month");
  let monthlyPrice = Number(monthlyPlan?.amount) || 0;

  const yearPlan = prices?.find((item) => item.interval === "year");
  let yearlyPrice = Number(yearPlan?.amount) || 0;

  if (!isEmpty(coupon)) {
    if (!isNull(amountOff)) {
      if (interval === "month") {
        monthlyPrice -= amountOff;
      } else {
        yearlyPrice -= amountOff;
      }
    }
    if (!isNull(percentOff)) {
      if (interval === "month") {
        monthlyPrice -= monthlyPrice * (percentOff / 100);
      } else {
        yearlyPrice -= yearlyPrice * (percentOff / 100);
      }
    }
  }

  const savings = monthlyPrice * 12 - yearlyPrice;
  const yearlyPriceByMonth = yearlyPrice / 12;

  return {
    selectedPlan,
    monthlyPlan,
    yearPlan,
    monthlyPrice: formatPrice(monthlyPrice),
    yearlyPrice: formatPrice(yearlyPrice),
    savings: formatPrice(savings),
    interval,
    yearlyPriceByMonth: formatPrice(yearlyPriceByMonth),
  };
};

export default useSubscriptionPlan;
